module.exports = "<unauthenticated-layout>\n</unauthenticated-layout>";